import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BannerImg from "../../../images/locationgcc/sa/Ksablack-1.webp";

function whychoose({ rtl }) {
  const className = rtl ? "whychoose p-100 rtl-style" : "whychoose  p-100";
  return (
    <div className={className} style={{ backgroundImage: `url(${BannerImg})` }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={8} xxl={8}>
            <div className="choose-main">
              <div className="choose-box">
                <div className="choose-num">
                  300+<span>التطبيقات المطورة</span>
                </div>
              </div>
              <div className="choose-box">
                <div className="choose-num">
                  65+<span>مراجعة</span>
                </div>
              </div>
              <div className="choose-box">
                <div className="choose-num">
                  35+<span>الصناعات المخدومة</span>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={12} lg={10} xl={10} xxl={10}>
            <h2>تطوير التطبيقات في دبي – دعم المشاريع لتحقيق النمو المستدام</h2>
            <p>
              تضم تيك ريفول شركة تصميم تطبيقات الجوال في دبي مجموعة من هواة
              الابداع الشغوفين المتطلعين دوماً لتطوير برمجيات طليعية في المجال
              الرقمي.
            </p>
            <p>
              ومع تدهور أسعار النفط نتيجة جائحة كوفيد 19 تضاعف الأعمال التجارية
              في منطقة دول مجلس التعاون الخليجي جهودها لتحقيق التحول الرقمي.
              التقنية والاستراتيجية بوصفنا شركة تطوير التطبيقات العاملة في دبي
              من الحفاظ على ريادتنا في سوق المجلس التنافسي ومساعدة الشركات في
              مختلف القطاعات على تحقيق إمكانياتها الحقيقية.
            </p>
            <p>
              نلتزم بمقاربة التطوير والاتصال السلسة منذ أولى مراحل التشاور
              الأولي مع العميل وصولاً إلى مرحلة التنفيذ والأنشطة التي تتبع إطلاق
              المنتج.
            </p>
            <p>
              يتميز فريقنا في شركة تطوير التطبيقات بالخبرة والتخصص المثاليين في
              مجال تطوير تطبيقات الجوال المتخصصة على نظامي أندرويد وآي أو إس
              وتطوير التطبيقات متعددة المنصات وألعاب الجوال لإنتاج أدوات تجارية
              تستطيع الوصول إلى الجمهور المستهدف وتضمن تجربة استخدام رائعة.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default whychoose;
